module.exports = __webpack_public_path__ + "static/media/share-square-solid-prod.849bfb4c.svg";